<template>
  <RecipesTable></RecipesTable>
  <app-sidebar-button></app-sidebar-button>
</template>

<script>
import AppSidebarButton from "../components/AppSidebarButton.vue";
import RecipesTable from "../components/recipe-category/RecipesTable.vue";
export default {
  components: {
    RecipesTable,
    AppSidebarButton,
  },
  data() {
    return {};
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>

<style></style>
